<template>
    <div class="card">
      <div class="card-header pb-0">
        <h6>Block Kerja Table</h6>
        <div class="row">
          <div class="col-md-2">
            <label for="example-text-input" class="form-control-label">Quick Search</label>
            <input
              type="text"
              v-model="searchQuery"
              placeholder="Search..."
              class="form-control mb-3"
              style="max-width: 250px; "
            />
          </div>
          <div class="col-md-2">
              <label for="example-text-input" class="form-control-label">Date From</label>
              <input type="date" id="input_date" class="form-control" v-model="search.datefrom">
          </div>
          <div class="col-md-2">
              <label for="example-text-input" class="form-control-label">Date To</label>
              <input type="date" id="input_date" class="form-control" v-model="search.dateto">
          </div>
          <div class="col-md-2">
              <label for="example-text-input" class="form-control-label">Type</label>
              <select class="form-control" v-model="search.type">
                <option value="0">All</option>
                <option value="1">Baja</option>
                <option value="2">Racun</option>
                <option value="3">Cuci</option>
                <option value="4">Labor</option>
                <option value="5">Others</option>
              </select>
          </div>
          <div class="col-md-2">
              <label for="example-text-input" class="form-control-label">Block ID</label>
              <input class="form-control" v-model="search.blockid" id="input_blockid" type="text" placeholderK="A01" />
          </div>
          <div class="col-md-2">
              <label for="example-text-input" class="form-control-label" style="width: 100%;">&nbsp;</label>
              <button class="btn btn-success " style="float:right;" id="btn_search" @click="getAllBlockKerjaList">Search</button>
          </div>
        </div>
        <hr />
        <div class="row">
            <div class="col-md-2">
                <label for="example-text-input" class="form-control-label">Total Labor: RM {{ ttlLabor }}</label>
            </div>
            <div class="col-md-2">
                <label for="example-text-input" class="form-control-label">Total Baja: RM {{ ttlBaja }}</label>
            </div>
            <div class="col-md-2">
                <label for="example-text-input" class="form-control-label">Total Cuci: RM {{ ttlCuci }}</label>
            </div>
            <div class="col-md-2">
                <label for="example-text-input" class="form-control-label">Total Racun: RM {{ this.ttlRacun }}</label>
            </div>
            <div class="col-md-2">
                <label for="example-text-input" class="form-control-label">Total Others: RM {{ ttlOthers }}</label>
            </div>
            <div class="col-md-2">
                <label for="example-text-input" class="form-control-label">Tota: RM {{ totalCost }}</label>
            </div>
        </div>
      </div>
      <hr />
      <div class="card-body px-0 pt-0 pb-2">
        <div class="table-responsive p-0">
          <table class="table align-items-center mb-0">
            <thead>
              <tr>
                <th class="text-uppercase text-xs font-weight-bolder">
                  Blockid
                </th>
                <th class="text-uppercase text-xs font-weight-bolder">
                  Kerja
                </th>
                <th class="text-uppercase text-xs font-weight-bolder">
                  Cost
                </th>
                <th class="text-uppercase text-xs font-weight-bolder">
                </th>
                <th class="text-uppercase text-xs font-weight-bolder">
                  Remarks
                </th>
                <th class="text-uppercase text-xs font-weight-bolder">
                  Date
                </th>
                <!-- <th class="text-uppercase text-xs font-weight-bolder">
                  
                </th> -->
                <!-- <th class="text-secondary opacity-7"></th> -->
              </tr>
            </thead>
            <tbody>
              <tr v-for="(kerja,index) in paginatedBlockkerja" :key="index">
                <td>
                  <div class="d-flex px-2 py-1">
                    <div class="d-flex flex-column justify-content-center">
                        <h6 class="mb-0 text-sm">{{ (currentPage-1)*10 + index +1 }}. {{ kerja.blockid }}</h6>
                        <span class="text-xs font-weight-bold" >
                        {{ kerja.blockname }}
                        </span>
                    </div>
                  </div>
                </td>
                <td class="align-middle">
                  <span class="text-xs font-weight-bold" >
                    {{ kerja.workdescription }}
                    </span>
                </td>
                <td class="align-middle">
                  <span class="text-xs font-weight-bold" >
                    Baja: RM {{ kerja.bajacost }} <br />
                    Labor: RM {{ kerja.laborcost }}
                    </span>
                </td>
                <td class="align-middle">
                  <span class="text-xs font-weight-bold" >
                    Racun: RM {{ kerja.racuncost }} <br /> Cuci: RM {{ kerja.cucicost }}<br />
                    Other: RM {{ kerja.othercost }}
                    </span>
                </td>
                <td class="align-middle">
                  <span class="text-xs font-weight-bold" >
                    {{ kerja.remark }}
                    </span>
                </td>
                <td class="align-middle">
                  <span class="text-xs font-weight-bold" >
                    {{ kerja.date }}
                    </span>
                </td>
                <!-- <td class="align-middle">
                  <button class="btn btn-danger font-weight-bold text-xs" @click="removeLorryService(kerja.blockid)">Remove</button>
                </td> -->
              </tr>
            </tbody>
          </table>
          <!-- Pagination Controls -->
          <hr />
          <div class="pagination-container">
            <div>
              <button @click="prevPage" :disabled="currentPage === 1" class="btn btn-info">Previous</button>
              <span class="form-control-label" style="padding:10px"> Page {{ currentPage }} of {{ totalPages }} </span>
              <button @click="nextPage" :disabled="currentPage === totalPages" class="btn btn-info">Next</button>
            </div>
            
            <span class="form-control-label total-rows">Total {{ totalRows }} entries </span>
          </div>
        </div>
      </div>
    </div>
  </template>
  
<script>
import axios from 'axios';

export default {
  name:'bblockKerjaSelect',
  data(){
    return {
        totalRows: 0,
        currentPage: 0,
        perPage: 10,
        searchQuery:'',
        ttlBaja:0.00,
        ttlRacun:0.00,
        ttlCuci:0.00,
        ttlOthers:0.00,
        ttlLabor:0.00,
        totalCost:0.00,
        blockkerja: [],
        removeLorrySevices: {
          id:''
        },
        search:{
          type:'0',
          dateto: new Date().toISOString().slice(0,10),
          datefrom: new Date(this.currentDate()).toISOString().slice(0,10),
          blockid: '',
        }
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.blockkerja.length / this.perPage);
    },
    paginatedBlockkerja() {
      const start = (this.currentPage - 1) * this.perPage;
      let query = this.searchQuery.toLowerCase();

      // Filter customers by checking all properties in each row
      let filtered = this.blockkerja.filter(item => {
        return Object.values(item).some(value =>
          String(value).toLowerCase().includes(query)
        );
      });
      return filtered.slice(start, start + this.perPage);
    }
  },
  mounted(){
    this.getAllBlockKerjaList();
  },
  methods: {
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    currentDate() {
      const firstDayMonth = new Date();
      const date = `${firstDayMonth.getMonth()+1}/02/${firstDayMonth.getFullYear()}`;
      return date;
    },
    getAllBlockKerjaList(){
        var blockid = '';
        blockid = this.search.blockid ;
        if(blockid == ""){
            blockid = 'all';
        }
        // var mythis = this;
        axios.get('block/listBlockKerja/' + this.search.datefrom + "/" + this.search.dateto + "/" + blockid + "/" + this.search.type)
            .then(res => {
                this.blockkerja = res.data.blockkerja;
                this.totalRows = res.data.blockkerja.length;
                this.ttlBaja = res.data.totalblockkerja[0].ttl_bajacost;
                this.ttlRacun = res.data.totalblockkerja[0].ttl_racuncost;
                this.ttlLabor = res.data.totalblockkerja[0].ttl_laborcost;
                this.ttlCuci = res.data.totalblockkerja[0].ttl_cucicost;
                this.ttlOthers = res.data.totalblockkerja[0].ttl_othercost;
                this.totalCost = res.data.totalblockkerja[0].totalCost;
                this.currentPage = 1;
            }).catch(function (error){
                if(error.response){
                    if(error.response.status == 422){
                        alert('Error: Name, Company, Contact, State and Address is required! ');
                    }
                }else if(error.request){
                    console.log(error.request);
                }else{
                    console.log('Error',error.message);
                }
            });
    },
  },
}
</script>